<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title aling="center">{{(user.nivel=='adm') ? 'Maestro de Evaluaciones' : 'Mis Evaluaciones Históricas'}}</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-btn absolute dark fab top right color="success" @click="nuevaevd" v-if="user.nivel == 'adm'">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-card-text>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            :headers="(user.nivel=='adm') ? headersAdm : headers"
            :items="datos"
            :items-per-page="5"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:item.descripcion="{ item }">
              <a @click="evaluacion(item.id)">{{item.descripcion}}</a>
            </template>
            <template v-slot:item.actions="{ item }">
              <!-- <v-icon small @click="evaluacion(item.id)">mdi-forward</v-icon> -->
              <v-icon small @click="editItem(item)" v-if="user.nivel == 'adm'">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)" v-if="user.nivel == 'adm'">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card>
<br>
    <v-card v-if="datosDis.length > 0">
      <v-toolbar color="red" dark>
        <v-toolbar-title aling="center">Evaluaciones Disconformes</v-toolbar-title>
      </v-toolbar>
      <v-card flat>

        <v-card-text>

          <v-text-field
            v-model="searchDis"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            :headers="headersDis"
            :items="datosDis"
            :items-per-page="5"
            class="elevation-1"
            :search="searchDis"
          >
            <template v-slot:item.descripcion="{ item }">
              <a @click="evaluacionDis(item.evaluacion,item.colaborador)">{{item.descripcion}}</a>
            </template>

          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card>

    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
              <v-toolbar color="primary" dark>
                  <v-toolbar-title aling="center">Descripción de la Evaluación</v-toolbar-title>
              </v-toolbar>
            <v-row align="center">
              <v-col cols="8">
                <v-text-field v-model="editedItem.descripcion" label="Descripcion de la Evaluación" required outlined></v-text-field>
              </v-col>
                <v-col cols="2">
                  <v-select :items="escala" v-model="editedItem.escala" label="Escala Evaluación 1-10" outlined></v-select>
                </v-col>  
                <v-col cols="2">
                  <v-select :items="escalaMes" v-model="editedItem.meses" label="Antigüedad Meses" outlined></v-select>
                </v-col>  

                <v-col cols="6">
                  <v-row align="center" class="grey lighten-2 rounded-pill">
                    <v-col cols="2">
                        <v-switch :label="editedItem.vcompetencias ? 'ON' : 'Off'" v-model="vcompetencias" color="orange"></v-switch>
                    </v-col>

                    <v-col cols="4">
                        Competencias: 
                        <v-progress-circular rotate="270" size="64" :value="editedItem.bcompetencias" width="10"
                        color="orange" @click="modporcen('com')">{{editedItem.bcompetencias}}</v-progress-circular>
                    </v-col>

                    <v-col cols="2">
                        <v-switch :label="editedItem.vobjetivos ? 'ON' : 'Off'" v-model="vobjetivos" color="indigo"></v-switch>
                    </v-col>

                    <v-col cols="4">
                      Objetivos:
                        <v-progress-circular rotate="270" size="64" :value="editedItem.bobjetivos" width="10"
                        color="indigo" @click="modporcen('kpi')">{{editedItem.bobjetivos}}</v-progress-circular>
                    </v-col>
                  </v-row>  
                </v-col>
                <v-col cols="6">
                  <v-row align="center" class="grey lighten-2 rounded-pill">  
                    <v-col cols="3">
                        <v-switch label="Medio Año" v-model="editedItem.medioano" color="red"></v-switch>
                    </v-col>

                    <v-col cols="4">
                        <v-switch label="Autoevaluación" v-model="editedItem.autoevaluacion" color="red"></v-switch>
                    </v-col>

                    <v-col cols="3">
                        <v-switch label="Sup Matr" v-model="editedItem.supmatricial" color="yellow"></v-switch>
                    </v-col>

                    <v-col cols="2" v-if="editedItem.supmatricial">
                        <v-switch label="Nota" v-model="editedItem.nota_matricial" color="yellow"></v-switch>
                    </v-col>

                  </v-row>
                </v-col>           
            </v-row>
              <v-toolbar color="primary" dark>
                  <v-toolbar-title aling="center">Calendario de la Evaluación</v-toolbar-title>
              </v-toolbar>
            <v-row align="center" align-content="center">
              <v-col cols="3">
                Etapa
              </v-col>
              <v-col cols="3">
                Inicia
              </v-col>
              <v-col cols="3">
                Finaliza
              </v-col>
              <v-col cols="1" style="font-size: 11px !important;">
                Respaldos                
              </v-col>
              <v-col cols="1" style="font-size: 11px !important;">
                Notificaciones
              </v-col>
              <v-col cols="1" style="font-size: 11px !important;">
                Avisos
              </v-col>
            </v-row>
            <!-- Datos de Inicio -->
            <v-row class="grey lighten-3 rounded-pill">
              <v-col cols="3" >
                <b >Proceso {{editedItem.descripcion}}</b>
              </v-col>
              <v-col cols="3">
                <v-text-field :value="editedItem.fecinicio" label="Fecha Inicio" readonly required outlined @click="fechas('inicio',null,editedItem.fecfin)"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field :value="editedItem.fecfin" label="Fecha Fin" readonly required outlined @click="fechas('fin')" :disabled="!editedItem.fechainicio"></v-text-field>
              </v-col>
              <v-col cols="1">
                -
              </v-col>
              <v-col cols="1">
                -
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_generales" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Fijacion de Objetivos -->
            <v-row align="center" align-content="center">
              <v-col cols="3" style="text-align: right;">
                Fijación de Objetivos Colaboradores
              </v-col>
              <v-col cols="3">
                <v-text-field :value="editedItem.fecinicio_col" label="Fecha Inicio" readonly required outlined @click="fechas('inicio_col',editedItem.fechainicio,editedItem.fechafin_col)" :disabled="!editedItem.fechafin"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field :value="editedItem.fecfin_col" label="Fecha Fin" readonly required outlined @click="fechas('fin_col',editedItem.fechainicio_col)" :disabled="!editedItem.fechainicio_col"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_col" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_col" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_col" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Revision de Objetivos -->
            <v-row align="center" align-content="center">
              <v-col cols="3" style="text-align: right;">
                Revisión y Seguimiento de Objetivos
              </v-col>
              <v-col cols="3">
                <v-text-field :value="editedItem.fecinicio_sup" label="Fecha Inicio" readonly required outlined @click="fechas('inicio_sup',editedItem.fechafin_col,editedItem.fechafin_sup)" :disabled="!editedItem.fechafin_col"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin_sup" label="Fecha Fin" readonly required outlined @click="fechas('fin_sup',editedItem.fechainicio_sup)" :disabled="!editedItem.fechainicio_sup"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_sup" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_sup" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_sup" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Evaluacion medio Año colaborador -->
            <v-row align="center" align-content="center" v-if="editedItem.autoevaluacion & editedItem.medioano">
              <v-col cols="3" style="text-align: right;">
                Evaluación Medio Año del Colaborador
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecinicio_med_col" label="Fecha Inicio" readonly required outlined @click="fechas('inicio_med_col',editedItem.fechafin_sup,editedItem.fechafin_med_col)" :disabled="!editedItem.fechafin_sup"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin_med_col" label="Fecha Fin" readonly required outlined @click="fechas('fin_med_col',editedItem.fechainicio_med_col)" :disabled="!editedItem.fechainicio_med_col"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_med_col" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_med_col" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_med_col" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Evaluacion medio Año supervisor -->
            <v-row align="center" align-content="center" v-if="editedItem.medioano">
              <v-col cols="3" style="text-align: right;">
                Evaluación Medio Año del Supervisor
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecinicio_med_sup" label="Fecha Inicio" readonly required outlined @click="editedItem.autoevaluacion ? fechas('inicio_med_sup',editedItem.fechafin_med_col,editedItem.fechafin_med_sup) : fechas('inicio_med_sup',editedItem.fechafin_sup,editedItem.fechafin_med_sup)" :disabled="editedItem.autoevaluacion ? !editedItem.fechafin_med_col : !editedItem.fechafin_sup"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin_med_sup" label="Fecha Fin" readonly required outlined @click="fechas('fin_med_sup',editedItem.fechainicio_med_sup)" :disabled="!editedItem.fechainicio_med_sup"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_med_sup" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_med_sup" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_med_sup" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Evaluacion medio Año matricial -->
            <v-row align="center" align-content="center" v-if="editedItem.medioano && editedItem.supmatricial">
              <v-col cols="3" style="text-align: right;">
                Evaluación Medio Año del Supervisor Matricial
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecinicio_med_supmat" label="Fecha Inicio" readonly required outlined @click="fechas('inicio_med_supmat',editedItem.fechafin_med_sup,editedItem.fechafin_med_supmat)" :disabled="editedItem.autoevaluacion ? !editedItem.fechafin_med_col : !editedItem.fechafin_sup"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin_med_supmat" label="Fecha Fin" readonly required outlined @click="fechas('fin_med_supmat',editedItem.fechainicio_med_supmat)" :disabled="!editedItem.fechainicio_med_sup"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_med_supmat" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_med_supmat" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_med_supmat" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Evaluacion Fin Año colaborador -->
            <v-row align="center" align-content="center" v-if="editedItem.autoevaluacion">
              <v-col cols="3" style="text-align: right;">
                Evaluación Final del Colaborador
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecinicio_fin_col" label="Fecha Inicio" readonly required outlined @click="(editedItem.medioano && editedItem.supmatricial) ? fechas('inicio_fin_col',editedItem.fechafin_med_supmat,editedItem.fechafin_fin_col) : editedItem.medioano ? fechas('inicio_fin_col',editedItem.fechafin_med_sup,editedItem.fechafin_fin_col) : fechas('inicio_fin_col',editedItem.fechafin_sup,editedItem.fechafin_fin_col)" :disabled="editedItem.medioano ? !editedItem.fechafin_med_sup : !editedItem.fechafin_sup"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin_fin_col" label="Fecha Fin" readonly required outlined @click="fechas('fin_fin_col',editedItem.fechainicio_fin_col)" :disabled="!editedItem.fechainicio_fin_col"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_fin_col" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_fin_col" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_fin_col" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Evaluacion Fin Año supervisor -->
            <v-row align="center" align-content="center">
              <v-col cols="3" style="text-align: right;">
                Evaluación Final del Supervisor
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecinicio_fin_sup" label="Fecha Inicio" readonly required outlined @click="editedItem.autoevaluacion ? fechas('inicio_fin_sup',editedItem.fechafin_fin_col,editedItem.fechafin_fin_sup) : fechas('inicio_fin_sup',editedItem.fechafin_sup,editedItem.fechafin_fin_sup)" :disabled="editedItem.autoevaluacion ? !editedItem.fechafin_fin_col : !editedItem.fechafin_sup"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin_fin_sup" label="Fecha Fin" readonly required outlined @click="fechas('fin_fin_sup',editedItem.fechainicio_fin_sup)" :disabled="!editedItem.fechainicio_fin_sup"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_fin_sup" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_fin_sup" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_fin_sup" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Evaluacion Fin Año matricial -->
            <v-row align="center" align-content="center" v-if="editedItem.supmatricial">
              <v-col cols="3" style="text-align: right;">
                Evaluación Final del Supervisor Matricial
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecinicio_fin_supmat" label="Fecha Inicio" readonly required outlined @click="fechas('inicio_fin_supmat',editedItem.fechafin_fin_sup,editedItem.fechafin_fin_supmat)" :disabled="!editedItem.fechafin_sup"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin_fin_supmat" label="Fecha Fin" readonly required outlined @click="fechas('fin_fin_supmat',editedItem.fechainicio_fin_supmat)" :disabled="!editedItem.fechainicio_fin_sup"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_fin_supmat" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_fin_supmat" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_fin_supmat" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Calibracion -->
            <v-row align="center" align-content="center">
              <v-col cols="3" style="text-align: right;">
                Calibración
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecinicio_cal" label="Fecha Inicio" readonly required outlined @click="editedItem.supmatricial ? fechas('inicio_cal',editedItem.fechafin_fin_supmat,editedItem.fechafin_cal) : fechas('inicio_cal',editedItem.fechafin_sup,editedItem.fechafin_cal)" :disabled="editedItem.supmatricial ? !editedItem.fechafin_fin_supmat : !editedItem.fechafin_fin_sup"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin_cal" label="Fecha Fin" readonly required outlined @click="fechas('fin_cal',editedItem.fechainicio_cal)" :disabled="!editedItem.fechainicio_cal"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_cal" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_cal" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_cal" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Retroalimentacion -->
            <v-row align="center" align-content="center">
              <v-col cols="3" style="text-align: right;">
                Retroalimentación
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecinicio_ret" label="Fecha Inicio" readonly required outlined @click="fechas('inicio_ret',editedItem.fechafin_cal,editedItem.fechainicio_req)" :disabled="!editedItem.fechafin_cal"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin_ret" label="Fecha Fin" readonly required outlined @click="fechas('fin_ret',editedItem.fechainicio_ret)" :disabled="!editedItem.fechainicio_ret"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_ret" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_ret" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_ret" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Firma Colaborador -->
            <v-row align="center" align-content="center">
              <v-col cols="3" style="text-align: right;">
                Proceso de Firma del Colaborador
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecinicio_fir_col" label="Fecha Inicio" readonly required outlined @click="fechas('inicio_fir_col',editedItem.fechafin_ret,editedItem.fechafin_fir_col)" :disabled="!editedItem.fechafin_cal"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin_fir_col" label="Fecha Fin" readonly required outlined @click="fechas('fin_fir_col',editedItem.fechainicio_fir_col)" :disabled="!editedItem.fechainicio_fir_col"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_fir_col" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_fir_col" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_fir_col" color="success"></v-switch>
              </v-col>
            </v-row>
            <!-- Firma supervisor -->
            <v-row align="center" align-content="center">
              <v-col cols="3" style="text-align: right;">
                Proceso de Firma del Supervisor
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecinicio_fir_sup" label="Fecha Inicio" readonly required outlined @click="fechas('inicio_fir_sup',editedItem.fechafin_fir_col,editedItem.fechafin_fir_sup)" :disabled="!editedItem.fechafin_fir_col"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="editedItem.fecfin_fir_sup" label="Fecha Fin" readonly required outlined @click="fechas('fin_fir_sup',editedItem.fechainicio_fir_sup)" :disabled="!editedItem.fechainicio_fir_sup"></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.res_fin_sup" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.not_fin_sup" color="success"></v-switch>
              </v-col>
              <v-col cols="1">
                <v-switch v-model="editedItem.avi_fin_sup" color="success"></v-switch>
              </v-col>
            </v-row>

          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog2" max-width="290" >
      <v-card>
        <v-card-title class="headline">0 al 100</v-card-title>
        <v-card-text>
          <v-slider v-if="dialogoType=='com'"
          v-model="bcompetencias" color="orange"
          thumb-label="always"
          ></v-slider>
          <v-slider v-else
          v-model="bobjetivos" color="indigo"
          thumb-label="always"
          ></v-slider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog2 = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog ref="dialog" v-model="modal" persistent width="290px">
        <v-date-picker header-color="success" v-model="date" scrollable v-if="dialogofType=='inicio'" :max="editedItem.fechafin" @input="fecAsig(dialogofType)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="fecCancel">Cancel</v-btn>
          <v-btn text color="primary" @click="fecAsig(dialogofType)">OK</v-btn>
        </v-date-picker>

        <v-date-picker header-color="orange" v-model="date" scrollable v-else-if="dialogofType=='fin'" :min="editedItem.fechainicio" @input="fecAsig(dialogofType)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="fecCancel">Cancel</v-btn>
          <v-btn text color="primary" @click="fecAsig(dialogofType)">OK</v-btn>
        </v-date-picker>

        <v-date-picker v-model="date" scrollable v-else :min="fechaAnt ? fechaAnt : editedItem.fechainicio" :max="fechaSig ? fechaSig : editedItem.fechafin" @input="fecAsig(dialogofType)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="fecCancel">Cancel</v-btn>
          <v-btn text color="primary" @click="fecAsig(dialogofType)">OK</v-btn>
        </v-date-picker>
      </v-dialog>

  </div>
</template>
<script>
import axios from "axios";
import api from "../conf/ruta-base";
import store from "../store";
import UserProfile from '../data';
import moment from "moment";
moment.locale('es');
import swal from 'sweetalert';
export default {
  name: "evaluaciones",
  data: () => ({
    apiPath: "evaluacion", search: "", searchDis: "", dialog: false, dialog2: false, modal: false,
    date: new Date().toISOString().substr(0, 10), dialogoType: "", dialogofType: "", slider:100,
    user: UserProfile.getUserData(),
    headersAdm: [
      { text: "Descripción", align: "start", sortable: true, value: "descripcion" },
      { text: "% Com", value: "bcompetencias" },
      { text: "% Obj", value: "bobjetivos" },
      { text: "Etapa Actual", value: "etapa" },
      { text: "Fecha Inicio", value: "fecinicio" },
      { text: "Fecha Fin", value: "fecfin" },
      { text: "Escala", value: "escala" },
      { text: "Estatus", value: "dstatus" },
      { text: "Operaciones", value: "actions", sortable: false }
    ],
    headers: [
      { text: "Descripción", align: "start", sortable: true, value: "descripcion" },
      { text: "% Com", value: "bcompetencias" },
      { text: "% Obj", value: "bobjetivos" },
      { text: "Responsable Actual", value: "dmedioano" },
      { text: "Fecha Inicio", value: "fecinicio" },
      { text: "Fecha Fin", value: "fecfin" },
      { text: "Escala", value: "escala" },
      { text: "Etapa", value: "paso" },
      { text: "Operaciones", value: "actions", sortable: false }
    ],
    headersDis: [
      { text: "Evaluación", align: "start", sortable: true, value: "descripcion" },
      { text: "Colaborador", value: "nombre" },
    ],    
    datos: [], datosDis:[], instituciones:[], selec: '',
    bcompetencias: 50, bobjetivos: 50, vcompetencias: true, vobjetivos: true, fechaAnt: null, fechaSig: null,
    escala: [1,2,3,4,5,6,7,8,9,10], escalaMes: [0,1,2,3,4,5,6,7,8,9,10,11,12],
    editedIndex: -1,
    editedItem: {
    },
    defaultItem: {
      id: "",descripcion: "",bcompetencias: 50,bobjetivos: 50,escala: 10,status: 1,medioano: true, autoevaluacion: true, paso: 0, vcompetencias: true, vobjetivos: true,meses: 6,
      fechainicio: '',fechafin: '',fecinicio: '',fecfin: '',res_generales: true,not_generales: true,avi_generales: true, supmatricial: false, nota_matricial: false,
      fechainicio_col: '',fechafin_col: '',fecinicio_col: '',fecfin_col: '',res_col: true,not_col: true,avi_col: true,
      fechainicio_sup: '',fechafin_sup: '',fecinicio_sup: '',fecfin_sup: '',res_sup: true,not_sup: true,avi_sup: true,
      fechainicio_med_sup: '',fechafin_med_sup: '',fecinicio_med_sup: '',fecfin_med_sup: '',res_med_sup: true,not_med_sup: true,avi_med_sup: true,
      fechainicio_med_col: '',fechafin_med_col: '',fecinicio_med_col: '',fecfin_med_col: '',res_med_col: true,not_med_col: true,avi_med_col: true,
      fechainicio_fin_sup: '',fechafin_fin_sup: '',fecinicio_fin_sup: '',fecfin_fin_sup: '',res_fin_sup: true,not_fin_sup: true,avi_fin_sup: true,
      fechainicio_fin_col: '',fechafin_fin_col: '',fecinicio_fin_col: '',fecfin_fin_col: '',res_fin_col: true,not_fin_col: true,avi_fin_col: true,
      fechainicio_fir_sup: '',fechafin_fir_sup: '',fecinicio_fir_sup: '',fecfin_fir_sup: '',res_fir_sup: true,not_fir_sup: true,avi_fir_sup: true,
      fechainicio_fir_col: '',fechafin_fir_col: '',fecinicio_fir_col: '',fecfin_fir_col: '',res_fir_col: true,not_fir_col: true,avi_fir_col: true,
      fechainicio_med_supmat: '',fechafin_med_supmat: '',fecinicio_med_supmat: '',fecfin_med_supmat: '',res_med_supmat: true,not_med_supmat: true,avi_med_supmat: true,
      fechainicio_fin_supmat: '',fechafin_fin_supmat: '',fecinicio_fin_supmat: '',fecfin_fin_supmat: '',res_fin_supmat: true,not_fin_supmat: true,avi_fin_supmat: true,
      fechainicio_cal: '',fechafin_cal: '',fecinicio_cal: '',fecfin_cal: '',res_cal: true,not_cal: true,avi_cal: true,
      fechainicio_ret: '',fechafin_ret: '',fecinicio_ret: '',fecfin_ret: '',res_ret: true,not_ret: true,avi_ret: true,
    },
  }),
  created() {
    this.editedItem = Object.assign({}, this.defaultItem);
  },
  mounted() {
    //Validamos la ruta si es admin o si es usr
    if(this.user.nivel=='adm'){
      var ruta = this.apiPath
    }else{
      var ruta = this.apiPath+'/misevaluaciones'
    }
    //consultamos la evaluacion
    axios
      .get(api.api + ruta)
      .then(r => {
      if(this.user.nivel=='adm'){
          for (let i = 0; i < r.data.length; i++) {
          let Val = Object.values(r.data[i])
          let Obj = Object.keys(r.data[i])
          for(let x = 0; x < Obj.length; x++){
            if(Obj[x].slice(0, 5)=='fecha'){
              r.data[i]['fec'+Obj[x].slice(5)]=this.fecCreate(Val[x]);
            }
          }
          r.data[i].dmedioano = '-';
          r.data[i].dstatus = (r.data[i].status==0) ? 'Inactiva':'Activa';
          this.datos.push(r.data[i]);
        }
      }else{
          for (let i = 0; i < r.data.length; i++) {
          let Val = Object.values(r.data[i].evacol)
          let Obj = Object.keys(r.data[i].evacol)
          for(let x = 0; x < Obj.length; x++){
            if(Obj[x].slice(0, 5)=='fecha'){
              r.data[i].evacol['fec'+Obj[x].slice(5)]=this.fecCreate(Val[x]);
            }
          }
          r.data[i].evacol.dmedioano = r.data[i].turno.nombres + ' ' + r.data[i].turno.apellidos
          r.data[i].evacol.paso = r.data[i].paso
          r.data[i].evacol.dstatus = (r.data[i].evacol.status==0) ? 'Inactiva':'Activa';
          this.datos.push(r.data[i].evacol);
        }
      }

      })
      .catch(error => {
        console.log(error);
      });
    if(this.user.nivel=='adm'){
      //Nos traemos el arreglo de las instituciones    
      axios
        .get(api.api + 'institucion')
        .then(r => {
          for (let i = 0; i < r.data.length; i++) {
            this.instituciones.push({
                text:r.data[i].nombre,
                value:r.data[i].id
                });
          }
        })
        .catch(error => {
          console.log(error);
        });


      //Nos traemos el arreglo de las disconformes
      axios
        .get(api.api + 'evaluacion/evaluacionesrechazadas')
        .then(r => {
          for (let i = 0; i < r.data.length; i++) {
            this.datosDis.push(r.data[i])
          }
        })
        .catch(error => {
          console.log(error);
        });
    }  
  },
  watch: {
    //Activamis los whatcer
    bcompetencias(valor){
      this.editedItem.bobjetivos = this.slider - valor;
      this.editedItem.bcompetencias = valor;
    },
    bobjetivos(valor){
      this.editedItem.bcompetencias = this.slider - valor;
      this.editedItem.bobjetivos = valor;
    },
    vcompetencias(valor){
      this.editedItem.vcompetencias = valor
      if(!valor){
        this.editedItem.vobjetivos = true
        this.vobjetivos = true
        this.editedItem.bcompetencias = 0
        this.editedItem.bobjetivos = 100
      }   
    },
    vobjetivos(valor){
      this.editedItem.vobjetivos = valor
      if(!valor){
        this.editedItem.vcompetencias = true
        this.vcompetencias = true
        this.editedItem.bcompetencias = 100
        this.editedItem.bobjetivos = 0
      }
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Evaluación de Desempeño" : "Modificar Evaluación de Desempeño";
    },
  },
  methods: {

    editItem(item) {
      this.editedIndex = this.datos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.vcompetencias = this.editedItem.vcompetencias
      this.vobjetivos = this.editedItem.vobjetivos
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    presave(){
      let bandera = true
      let err = ''
        if(bandera && this.editedItem.descripcion.length == 0){
          bandera = false
          err = 'Debe ingresar un nombre descriptivo de la Evaluacion.'
        }

        if(bandera && (this.editedItem.fechainicio.length == 0 || this.editedItem.fechafin.length == 0)){
          bandera = false
          err = 'Debe especificar las fechas de Inicio y Fin del Proceso'
        }
  
        if(bandera && (this.editedItem.fechainicio_col.length == 0 || this.editedItem.fechafin_col.length == 0)){
          bandera = false
          err = 'No ingreso las fechas disponibles al colaborador'
        }

        if(bandera && (this.editedItem.fechainicio_sup.length == 0 || this.editedItem.fechafin_sup.length == 0)){
          bandera = false
          err = 'No ingreso las fechas disponibles al supervisor'
        }

        if(bandera && (this.editedItem.fechainicio_fin_sup.length == 0 || this.editedItem.fechafin_fin_sup.length == 0)){
          bandera = false
          err = 'No ingreso las fechas disponibles al la evaluacion del supervisor'
        } 

        if(bandera && (this.editedItem.fechainicio_fir_col.length == 0 || this.editedItem.fechafin_fir_col.length == 0)){
          bandera = false
          err = 'No ingreso las fechas de firma del colaborador'
        }

        if(bandera && (this.editedItem.fechainicio_fir_sup.length == 0 || this.editedItem.fechafin_fir_sup.length == 0)){
          bandera = false
          err = 'No ingreso las fechas de firma del supervisor'
        }

      if(bandera){
        this.save()
      }else{
        swal('',err,'error');
      }
      
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.datos[this.editedIndex], this.editedItem);
        axios
          .put(api.api + this.apiPath, this.editedItem)
          .then(res => {
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        axios
          .post(api.api + this.apiPath, this.editedItem)
          .then(r => {
            let Val = Object.values(r.data)
            let Obj = Object.keys(r.data)
            for(let x = 0; x < Obj.length; x++){
              if(Obj[x].slice(0, 5)=='fecha'){
                r.data['fec'+Obj[x].slice(5)]=this.fecCreate(Val[x]);
              }
            }
            r.data.dmedioano = '-';
            r.data.etapa = 'Por parametrizar'
            r.data.dstatus = (r.data.status==0) ? 'Inactiva':'Activa';
            this.datos.push(r.data);
            this.toast(r.data.c, r.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      }
      this.close();
    },
    
    deleteItem (item) {
      const index = this.datos.indexOf(item)
      swal({text: "¿Seguro que desea eliminar? Se eliminaran los objetivos, las competencias y todo lo relacionado a esta evaluación",icon: "warning", buttons: ["Cancelar", "Ok"],})
      .then(ok => {         
        if(ok){
          axios.delete(api.api + this.apiPath, {data: item})
          .then(res => {
            if(res.data.c=='success'){
              this.datos.splice(index, 1)
            }
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
        }
      })
    },
    
    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    },

    fecCancel(){
      this.fechaSig = null
      this.modal = null
    },

    fecCreate(fec){
      if(fec != '' & fec != '0000-00-00 00:00:00'){
        let date = moment(fec).format('L');
          return date;
      }else{
          return '';
      }
    },

    fecAsig(fec){
      let [year, month, day] = this.date.split('-')
      let date = day.padStart(2, '0') + '/' + month.padStart(2, '0') + '/' + year;
        this.editedItem['fec'+fec] = date;
        this.editedItem['fecha'+fec] = this.date;
      this.dialogofType = '';
      this.modal = false;
      this.fechaSig = null
      this.date = new Date().toISOString().substr(0, 10);
    },

    modporcen(evento){
        if(evento=='com'){
          this.dialogoType='com';
        }else{
          this.dialogoType='kpi';
        }
        this.dialog2 = true;
    },

    fechas(evento,limite=null,sig=null){
      console.log({evento,limite,sig})
        if(sig){
          this.fechaSig = sig
        }
        if(limite){
          this.fechaAnt = limite
        }else{
          this.fechaAnt = null
        }
        this.dialogofType = evento;
        this.modal = true;
    },

    nuevaevd(){
        this.bcompetencias = 50
        this.bobjetivos = 50
        this.dialog = true
    },

    evaluacionDis(ev,emp){
      this.$router.push('/evaluacion/'+ev+'/'+emp);
    },

    evaluacion(id){
      if(this.user.nivel=='adm'){
        this.$router.push('/evaluacionadm/'+id);
      }else{
        this.$router.push('/evaluacion/'+id);
      }
    }
  }
};
</script>